import { gql } from '@apollo/client';
import { useApolloClient, useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

const updateMutation = gql`
    mutation updateGuest($updates: GuestUpdates!) {
        updateGuest(updates: $updates)
    }
`;

const useUpdateGuestField = <T>({
    id,
    field,
    initialValue,
    defaultValue,
    isNumeric,
}: {
    id: string | number;
    field: string;
    initialValue: T;
    defaultValue: T;
    isNumeric?: boolean;
}) => {
    const client = useApolloClient();
    const [currentValue, setCurrentValue] = useState<T>(
        initialValue || defaultValue
    );
    const [performUpdate] = useMutation(updateMutation);

    const update = useCallback(() => {
        performUpdate({
            variables: {
                updates: {
                    id,
                    [field]: isNumeric ? +currentValue : currentValue,
                },
            },
        })
            .then(async () => {
                await client.clearStore();
                await client.refetchObservableQueries();
            })
            .catch(error => {
                throw error;
            });
    }, [currentValue, id, client, performUpdate, field, isNumeric]);

    return {
        currentValue,
        setValue: setCurrentValue,
        update,
    };
};

export default useUpdateGuestField;
